import { render, staticRenderFns } from "./ResetMasukanOtpPassword.vue?vue&type=template&id=4be5f8fe&scoped=true"
import script from "./ResetMasukanOtpPassword.vue?vue&type=script&lang=js"
export * from "./ResetMasukanOtpPassword.vue?vue&type=script&lang=js"
import style0 from "./ResetMasukanOtpPassword.vue?vue&type=style&index=0&id=4be5f8fe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4be5f8fe",
  null
  
)

export default component.exports